export const SECRET_KEY: string = 'yHkm7fiS3rdfXwfG';
